import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import fetchReviewList from '@custom/rtk-apis/myworklist/myworkList';
import { ReviewState } from '@custom/Utils/constants/interfaces';

const initialState: ReviewState = {
    reviewdata: [],
    status: "",
    loading: false,
    error: null,
    msg: null,
};

const reviewSlice = createSlice({
    name: 'review',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchReviewList.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.status = 'pending';
            })
            .addCase(fetchReviewList.fulfilled, (state, action: PayloadAction<any>) => {
                state.loading = false;
                state.status = action.payload.status || 'SUCCESS'; // Set status from the response
                state.reviewdata = action.payload.result.list || [];  // Assuming data is in the `data` field
                state.msg = action.payload.msg || null; // Set message if available
            })
            .addCase(fetchReviewList.rejected, (state, action: PayloadAction<any>) => {
                state.loading = false;
                state.status = 'rejected';
                state.error = action.payload || 'Failed to fetch review list';
                state.msg = action.payload?.msg || null; // Set error message if available
            });
    },
});

export default reviewSlice.reducer;
